import { render, staticRenderFns } from "./ProjectEditing.vue?vue&type=template&id=3bdefac5&scoped=true&"
import script from "./ProjectEditing.vue?vue&type=script&lang=js&"
export * from "./ProjectEditing.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEditing.vue?vue&type=style&index=0&id=3bdefac5&prod&lang=scss&scoped=true&"
import style1 from "./ProjectEditing.vue?vue&type=style&index=1&id=3bdefac5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdefac5",
  null
  
)

export default component.exports